export const useIsDevEnvironment = () => {
  const isDevelopment = process.env.NODE_ENV === "development";
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
  const isProductionExplicitlySet =
    process.env.NEXT_PUBLIC_IS_PRODUCTION === "true";

  const isDevEnvironment =
    (isDevelopment || isPreview) && !isProductionExplicitlySet;

  return isDevEnvironment;
};
